<template>
    <div id="app">
    <b-button v-b-toggle.collapse-instructions variant="primary" size="sm" style="width: 110px;">
        <span>Instructions</span>
    <strong v-if="isVisible" aria-hidden="true" style="padding: 5px">-</strong>
    <strong v-else aria-hidden="true" style="padding: 5px">+</strong>
    </b-button>
    <b-collapse id="collapse-instructions" v-model="isVisible">
        <p>Use the "Search by phrase..." field to search for one or more terms (separated by a space) within 
        any column.</p>
        <p>To search a specific column by various criteria, use the three fields to select a column, an 
        operator (see below) and search term. Use the "+" button to add another column search field set.</p>
        <p>Click the "Search" button or hit the Enter key to initiate the search.</p>
        <table class="instructionsTable">
            <tr>
                <td colspan=3><u>Search operator definitions:</u></td>
            </tr>
            <tr>
                <td><b>=</b></td>
                <td>Column value equal to</td>
                <td>Case sensitive. Searches for rows where the requested column is an exact match for the provided string.</td>
            </tr>
            <tr>
                <td><b>!=</b></td>
                <td>Column value not equal to</td>
                <td>Case sensitive. Searches for rows where the requested column is not an exact match for the provided string.</td>
            </tr>
            <tr>
                <td><b>contains</b></td>
                <td>Column value contains</td>
                <td>Not case sensitive. Searches for rows where the requested column contains the provided string.</td>
            </tr>
            <tr>
                <td><b>!contains</b></td>
                <td>Column value does not contain</td>
                <td>Not case sensitive. Searches for rows where the requested column does not contain the provided string.</td>
            </tr>
            <tr>
                <td><b>starts with</b></td>
                <td>Column value starts with</td>
                <td>Case sensitive. Searches for rows where the requested column starts with the provided string.</td>
            </tr>
            <tr>
                <td><b>!starts with</b></td>
                <td>Column value does not start with</td>
                <td>Case sensitive. Searches for rows where the requested column does not start with the provided string.</td>
            </tr>
            <tr>
                <td><b>&#60;</b></td>
                <td>Column value less than</td>
                <td>Searches for rows where the requested column's value is less than the provided numerical input.</td>
            </tr>
            <tr>
                <td><b>&#60;=</b></td>
                <td>Column value less than or equal to</td>
                <td>Searches for rows where the requested column's value is less than or equal to the provided numerical input.</td>
            </tr>
            <tr>
                <td><b>&#62;</b></td>
                <td>Column value greater than</td>
                <td>Searches for rows where the requested column's value is greater than the provided numerical input.</td>
            </tr>
            <tr>
                <td><b>&#62;=</b></td>
                <td>Column value greater than or equal to</td>
                <td>Searches for rows where the requested column's value is greater than or equal to the provided numerical input.</td>
            </tr>
            <tr>
                <td><b>in</b></td>
                <td>Column value is in list.</td>
                <td>Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column's value is equal to one of the strings in the provided list.</td>
            </tr>
            <tr>
                <td><b>!in=</b></td>
                <td>Column value is not in list.</td>
                <td>Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column's value is not equal to one of the strings in the provided list.</td>
            </tr>
        </table>

        <p>To learn more about what each column represents, visit the
            <router-link :to="isVectraitsRoute ? { name: 'vectraits-columndefs', params: { } } : { name: 'vecdyn-columndefs', params: { } }">
                <u>field definitions section</u>
            </router-link>.
        </p>
        <p>To download datasets, select one or more records by clicking the checkbox to the left of each desired row. 
            Note that downloads are restricted to 3,000 datasets. The <i>Select All Rows</i> button will be disabled 
            unless the search performed returns 3,000 records or less.
        </p>
    </b-collapse>
    </div>
</template>
<script>
    export default {
        data() {
        return {
            isVisible: false
        }},
        computed: {
            isVectraitsRoute() { return this.$route.name === 'vectraits-explorer' }
        }
    };
</script>
<style>
    .instructionsTable td {
        padding: 0 15px;
        vertical-align: top;
        font-size: smaller;
    }
</style>